import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

@Injectable()
/**
 * The purpose of the AuthorizationGuard is to
 * grant / deny route permissions for specific
 * user roles.
 */
export class AuthorizationGuard implements CanActivate, CanActivateChild {

  constructor(

  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // TODO: Actual authorization checks...

    return true;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {

    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/auth/src/app/services/authorization.guard.ts